import { css } from '@emotion/react'
import { Color, Shadow, ShadowElevation, Size, Spacing } from '@opallabs/gem'

export const bubbleMenu = css({
  border: `1px solid ${Color.light['Strokes/Secondary-1']}`,
  borderRadius: Size.Rounding * 2,
  padding: Spacing.S,
  backgroundColor: Color.light['Color/Surface/Surface-1'],
  boxShadow: Shadow[ShadowElevation.E1].boxShadow,
  display: 'flex',
  alignItems: 'center',
})

export const separator = css({
  blockSize: '24px',
  marginInlineStart: Spacing.S,
  marginInlineEnd: Spacing.S,
  borderInlineEnd: `1px solid ${Color.light['Strokes/Secondary-1']}`,
})

export const button = css({
  marginInlineEnd: Spacing.XS,
})
